import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ItemCreateRequest, ItemCreateResponse, ItemResponse, ItemUpdateRequest} from "./model";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(public http: HttpClient,) {
  }

  getItems(): Observable<ItemResponse[]> {
    return this.http.get<ItemResponse[]>(environment.apiUrl + "/items");
  }

  getItem(itemId: number): Observable<ItemResponse> {
    return this.http.get<ItemResponse>(environment.apiUrl + "/items/" + itemId);
  }

  updateItem(itemId: number, item: ItemUpdateRequest): Observable<ItemResponse> {
    return this.http.patch<ItemResponse>(environment.apiUrl + "/items/" + itemId, item);
  }

  createItem(body: ItemCreateRequest): Observable<ItemCreateResponse> {
    return this.http.post<ItemCreateResponse>(environment.apiUrl + "/items", body);
  }

  deleteItem(item_id: number): Observable<any> {
    return this.http.delete<void>(environment.apiUrl + "/items/" + item_id);
  }
}

